module.exports = __webpack_public_path__ + "img/defaultImg.bd7b49b9.png";